import { save } from '@/helpers/storage';
import { event } from 'vue-analytics';
const mutations = {
    setProfileIds(state, profileIds) {
        state.profileIds = profileIds.sort(); // sort ids. caching will work better
        save(`selected_profiles`, profileIds);
    },
    setTimeRange(state, { widget, min, max }) {
        state.widgets[widget].timeRange = { min, max };
        save(`widgets_${widget}_timeRange`, { min, max });
        event('config-store', 'commit-setTimeRange', widget, max - min);
    },
};
export default mutations;
